/* import __COLOCATED_TEMPLATE__ from './target-misses-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();